import { createContext, ReactNode, useCallback, useState } from 'react';

type CardContextType = {
  cardNumber: string;
  expirationDate: string;
  cvv: string;
  pin: string;
  /** The brand from the BIN lookup, as returned; its casing varies. */
  cardBrand: string;
  /** The provider's instruction for the OTP screen, when it sends one. */
  otpPrompt: string;
  changeCardDetails: (details: Partial<CardContextType>) => void;
  tokenizeCard?: boolean;
};

export const CardContext = createContext<CardContextType>({
  cardNumber: '',
  expirationDate: '',
  cvv: '',
  pin: '',
  cardBrand: '',
  otpPrompt: '',
  changeCardDetails: () => {},
  tokenizeCard: false,
});

const CardProvider = ({ children }: { children: ReactNode }) => {
  const [cardDetails, setCardDetails] = useState<CardContextType>({
    cardNumber: '',
    expirationDate: '',
    cvv: '',
    pin: '',
    cardBrand: '',
    otpPrompt: '',
    changeCardDetails: () => {},
    tokenizeCard: false,
  });

  const changeCardDetails = useCallback(
    (details: Partial<CardContextType>) => {
      setCardDetails((prevDetails) => ({
        ...prevDetails,
        ...details,
      }));
    },
    [setCardDetails]
  );

  return (
    <CardContext.Provider value={{ ...cardDetails, changeCardDetails }}>
      {children}
    </CardContext.Provider>
  );
};

export default CardProvider;
